import SponsorshipTierList from "./SponsorshipTierList";

export default SponsorshipTierList